import getAbsoluteUrl from '@/utils/getAbsoluteUrl';

export const JD_OAUTH_CALLBACK_URL = getAbsoluteUrl('/oauth-jd-callback');
export const CASE_OAUTH_CALLBACK_URL = getAbsoluteUrl('/oauth-case-callback');

const endpoints = {
  http: import.meta.env.VITE_APP_API_HTTP_URL!,
  wss: import.meta.env.VITE_APP_API_WSS_URL!,
};

const config = {
  AppSync: {
    graphqlEndpoint: endpoints.http,
    websocketsEndpoint: endpoints.wss,
    region: import.meta.env.VITE_APP_AWS_REGION,
    authenticationType: import.meta.env.VITE_APP_AWS_AUTH_TYPE,
  },
  Auth: {
    // REQUIRED - Amazon Cognito Region
    region: import.meta.env.VITE_APP_AWS_REGION,

    // OPTIONAL - Amazon Cognito Federated Identity Pool Region
    // Required only if it's different from Amazon Cognito Region
    identityPoolRegion: import.meta.env.VITE_APP_AWS_REGION,

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: import.meta.env.VITE_APP_AWS_USER_POOL_ID,

    identityPoolId: import.meta.env.VITE_APP_AWS_IDENTITY_POOL_ID,

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: import.meta.env.VITE_APP_AWS_USER_POOL_CLIENT_ID,

    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: true,
    oauth:
      // Workaround: this is to avoid that Amplify OAuth try to parse EVERY url as a OAuth callback url
      // https://stackoverflow.com/questions/59883011/how-to-avoid-that-aws-amplify-oauth-tries-to-parse-every-oauth-process
      window.location.href.includes(JD_OAUTH_CALLBACK_URL) ||
      window.location.href.includes(CASE_OAUTH_CALLBACK_URL)
        ? undefined
        : {
            domain: import.meta.env.VITE_APP_AWS_COGNITO_OAUTH_DOMAIN,
            // Merging identities sends this access token to the API, which
            // checks it with Cognito's GetUser: that call needs the admin scope.
            scope: [
              'email',
              'profile',
              'openid',
              'aws.cognito.signin.user.admin',
            ],
            redirectSignIn: window.location.origin,
            redirectSignOut: window.location.origin,
            responseType: 'code',
            mandatorySignIn: true,
          },
  },
};

export { config };
